export const DataLayerServiceModule = angular
    .module('app.services.tracking.enhancedEcommerce.dataLayer', [])
    .service('dataLayer', ($window) => {
        function logCheckoutStep(stepNumber, optionValue, products) {
            $window.dataLayer.push({
                event: 'checkout',
                ecommerce: {
                    checkout: {
                        actionField: { step: stepNumber, option: optionValue },
                        products: products
                    }
                }
            });
        }

        function logAddToCart(currencyCode, products) {
            $window.dataLayer.push({
                event: 'addToCart',
                ecommerce: {
                    currencyCode: currencyCode,
                    add: { products: products }
                }
            });
        }

        function logRemoveFromCart(products) {
            $window.dataLayer.push({
                event: 'removeFromCart',
                ecommerce: {
                    remove: { products: products }
                }
            });
        }

        function logProductImpression(impressions) {
            $window.dataLayer.push({
                event: 'productImpressions',
                ecommerce: {
                    impressions: impressions
                }
            });
        }

        function logProductClick(products, listType) {
            $window.dataLayer.push({
                event: 'productClick',
                ecommerce: {
                    click: updateActionFields(products, listType)
                }
            });
        }

        function logProductDetails(products, listType) {
            $window.dataLayer.push({
                event: 'productDetails',
                ecommerce: {
                    detail: updateActionFields(products, listType)
                }
            });
        }

        function logCouponError(couponCode) {
            $window.dataLayer.push({
                event: 'couponError',
                couponCode
            });
        }

        function updateActionFields(products, listType) {
            let actionFieldObject = { products: products };
            if (listType) {
                actionFieldObject.actionField = { list: listType };
            }
            return actionFieldObject;
        }

        function logPurchase(purchaseId, affiliation, revenue, tax, products, paidWith, couponCode) {
            $window.dataLayer.push({
                event: 'productPurchase',
                ecommerce: {
                    purchase: {
                        actionField: {
                            id: purchaseId,
                            affiliation: affiliation,
                            revenue: revenue,
                            tax: tax,
                            paidWith: paidWith,
                            coupon: couponCode
                        },
                        products: products
                    }
                }
            });
        }

        function create({ productCode, title, price, variant }, category, listType, position) {
            let payload = {
                name: title,
                id: productCode,
                price: price,
                category: category,
                variant: variant,
                brand: 'v2'
            };
            if (angular.isDefined(listType)) {
                payload.list = listType;
            }
            if (isFinite(position)) {
                payload.position = position;
            }
            return payload;
        }

        return {
            logCheckoutStep,
            logAddToCart,
            logCouponError,
            logRemoveFromCart,
            logProductImpression,
            logProductClick,
            logProductDetails,
            logPurchase,
            create
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/tracking/enhancedEcommerce/dataLayer.service.js